<template>
  <v-textarea :readonly="readonly" auto-grow v-model="value" :label="prop.text" :clearable="!readonly"
    :color="prop.color" :name="prop.text" :error-messages="error">
  </v-textarea>
</template>

<style scoped>

</style>

<script>
  import TextAreaInput from "./textAreaInput.ts";
  export default TextAreaInput;
</script>